module.exports = __webpack_public_path__ + "media/images/illustrations/sparkle_large-436728ec95839b422b551101c26da414.svg";